import { render, staticRenderFns } from "./nianLingFenXi.vue?vue&type=template&id=4718871d&scoped=true"
import script from "./nianLingFenXi.vue?vue&type=script&lang=js"
export * from "./nianLingFenXi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718871d",
  null
  
)

export default component.exports